import Configuracao from "../misc/Configuracao";
import { MotivoAndamento } from "../modelo/MotivoAndamento";
import fetch from "./AxiosAdapter";


class MotivoAndamentoApi {
    async buscarMotivosAndamento(){
        const result = await fetch<MotivoAndamento[]>(Configuracao.urlMotivosAndamento, {
            timeout: 30000
        });
        return result.data;
    }
}

export default new MotivoAndamentoApi();